<template>
    <h1>Select Products</h1>
    <p>Select products to add to your quote from the list below.</p>
    <div class="products-filter">
        <label class="products-filter__label" for="category-select">Filter:</label>
        <select class="products-filter__select" v-model="selectedCategory">
            <option value="All">All</option>
            <option v-for="category in categories" :key="category" :value="category">
                {{ category }}
            </option>
        </select>
    </div>
    <div>
        <div v-for="product in filterByCategory" :key="product.id" class="col product">
            <a :href="product.url" :class="isInBasket(product) ? 'in-basket' : ''" class="product__image-link">
                <img :src="product.thumbnail" :alt="product.thumbnailAlt">
            </a>
            <div class="content">
                <h2><a :href="product.url">{{ product.title }}</a></h2>
                <h3><span v-if="product.purchasables.length > 1">from </span>£{{ product.fromPrice }}</h3>
                <p>{{ product.excerpt }}</p>
                <div class="basket-quick-add" >
                    <BasketQuickAdd :purchasables="product.purchasables" :productUrl="product.url"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import BasketQuickAdd from './BasketQuickAdd.vue';
    import { useBasketStore } from './store';

    const props = defineProps({
        products: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            required: true
        }
    });

    const selectedCategory = ref('All');

    const basketStore = useBasketStore();

    const filterByCategory = computed(() => {
        if (selectedCategory.value === 'All') {
            return props.products;
        }
        return props.products.filter(product => product.category === selectedCategory.value);
    });

    const isInBasket = (product) => {
        const purchasableIds = product.purchasables.map(p => p.id);
        return basketStore.items.some(item => purchasableIds.includes(item.id));
    };

    // Watch for category changes and update URL
    watch(selectedCategory, (newCategory) => {
        const url = new URL(window.location);
        if (newCategory == 'All') {
            url.searchParams.delete('category');
        } else {
            url.searchParams.set('category', newCategory);
        }
        window.history.pushState({}, '', url);
    });

    // check selected cat on page load
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
        selectedCategory.value = categoryParam;
    }
</script>

<style scoped>
    .in-basket {
        border: 4px solid #fabe4a;
        display: block;
        position: relative;
    }

    .in-basket::after {
        content: 'Selected';
        position: absolute;
        top: 0;
        left: 0;
        background: #fabe4a;
        color: #1D2243;
        padding: 2px 10px 5px 6px;
    }

    h1 {
        text-align: left;
    }

    .products-filter {
        margin: 1.5rem 0;
        display: flex;
        justify-content: stretch;
        align-items: baseline;
        gap: 1rem;
        color: #666666
    }

    .products-filter__select {
        border: none;
        padding: 10px;
        appearance: none;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/></svg>');
        background-repeat: no-repeat;
        background-position: right 10px center;
        width: 180px;
    }

    .products-filter__select:focus {
        outline: 2px solid #1D2243;
    }
</style>